import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import type { ErrorMessage, Workout, WorkoutCreate } from 'types';
import { client } from 'utils/api-client';

export default function useAssignWorkout(
  replacesWorkoutId?: string,
): UseMutationResult<AxiosResponse<Workout>, AxiosError<ErrorMessage>, WorkoutCreate> {
  const queryClient = useQueryClient();
  const path = replacesWorkoutId ? `workouts/${replacesWorkoutId}/replace/` : 'workouts/';

  return useMutation((workout: WorkoutCreate) => client.post(path, workout), {
    onSuccess: () => {
      if (replacesWorkoutId) queryClient.removeQueries(['workouts', replacesWorkoutId]);
      queryClient.invalidateQueries('workouts');
    },
  });
}
